export const API_ROUTES = {
  AUTH_CALLBACK: "/oauth2-callback",
};

export const APP_ROUTES = {
  BASE_URL: ".api.riotgames.com/",
};
